import React from 'react'
import ProtectionSuccess from '../protection-success'

const ProtectionSuccessEn = () => {
    return <ProtectionSuccess languageCode="en" />
}

export default ProtectionSuccessEn
